module.exports = __webpack_public_path__ + "static/media/doted.6c75926d.svg";